import { render, staticRenderFns } from "./statusEdit.vue?vue&type=template&id=50f3c72e&scoped=true&"
import script from "./statusEdit.vue?vue&type=script&lang=js&"
export * from "./statusEdit.vue?vue&type=script&lang=js&"
import style1 from "./statusEdit.vue?vue&type=style&index=1&id=50f3c72e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f3c72e",
  null
  
)

export default component.exports